interface ReportPaginationState {
  first: number
  rows: number
  pageSizes: number[]
}

/** Attach only a controller-reported total; one visible page cannot prove the result size. */
export function resolveReportPagination<T extends ReportPaginationState>(
  pagination: T | null,
  total: unknown,
): (T & { total: number }) | null {
  if (!pagination || typeof total !== 'number' || !Number.isFinite(total) || total < 0) return null
  return { ...pagination, total: Math.floor(total) }
}
